import {
  createMaintenanceApi,
  deleteMaintenanceApi,
  getAllMaintenanceApi,
  getMaintenanceByIdApi,
  updateMaintenanceApi,
  deleteMaintenanceImageApi,
} from "../../helpers/backend_helper";
import {
  getMaintenanceList,
  maintenanceByIdData,
  errorMessages,
  loadingData,
} from "./reducer";

export const getAllMaintenanceList =
  (currentPage, pageSize, searchText) => async (dispatch) => {
    try {
      dispatch(loadingData({ type: "read", value: true }));
      let response;
      response = getAllMaintenanceApi(currentPage, pageSize, searchText);
      const data = await response;
      dispatch(getMaintenanceList(data));
    } catch (error) {
      dispatch(errorMessages("Some thing went wrong, please try later"));
    } finally {
      dispatch(loadingData({ type: "read", value: false }));
    }
  };

export const getMaintenanceById = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "getById", value: true }));
    let response;
    response = getMaintenanceByIdApi(id);
    const data = await response;
    dispatch(maintenanceByIdData(data));
  } catch (error) {
    const errorMessage = error?.response?.data?.detail;
    dispatch(errorMessages(errorMessage));
  } finally {
    dispatch(loadingData({ type: "getById", value: false }));
  }
};

export const createMaintenance = (data) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "create", value: true }));
    const response = await createMaintenanceApi(data);
    return { success: true, message: "Maintenance Successfully Created" };
  } catch (error) {
    const errorMessage = error?.response?.data?.detail;
    return {
      success: false,
      message: errorMessage || "Failed to create maintenance",
    };
  } finally {
    dispatch(loadingData({ type: "create", value: false }));
  }
};

export const updateMaintenance = (id, data) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "update", value: true }));

    let response;
    response = await updateMaintenanceApi(id, data);
    return { success: true, message: "Maintenance Successfully Updated" };
  } catch (error) {
    const errorMessage = error.response.data.detail;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage }
  } finally {
    dispatch(loadingData({ type: "update", value: false }));
  }
};

export const deleteMaintenance = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "delete", value: true }));
    const response = await deleteMaintenanceApi(id);
    return { success: true, message: "Maintenance Successfully Deleted" };
  } catch (error) {
    const errorMessage = error.response.data.detail;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage }
  } finally {
    dispatch(loadingData({ type: "delete", value: false }));
  }
};


export const deleteMaintenanceImage = (id) => async (dispatch) => {
  try {
    dispatch(loadingData({ type: "deleteImage", value: true }));
    const response = await deleteMaintenanceImageApi(id);
    return { success: true, message: "Maintenance Successfully Deleted" };
  } catch (error) {
    const errorMessage = error.response.data.detail;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage }
  } finally {
    dispatch(loadingData({ type: "deleteImage", value: false }));
  }
};